import { api_GET } from "api/axios.js";

const transportador_api =
{
    getByCNPJ: function(cnpj){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`transportador/GetByCNPJ/${cnpj}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getVeiculosAtivos: function(id){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`transportador/GetVeiculosAtivos/${id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getMotoristasAtivos: function(id){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`transportador/GetMotoristasAtivos/${id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    }

}

export default transportador_api
